import { render } from "./Tal_formLine.vue?vue&type=template&id=4cd18f13&scoped=true"
import script from "./Tal_formLine.vue?vue&type=script&lang=js"
export * from "./Tal_formLine.vue?vue&type=script&lang=js"

import "./Tal_formLine.vue?vue&type=style&index=0&id=4cd18f13&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd18f13"]])

export default __exports__